module.exports = __webpack_public_path__ + "img/mau3-2-nhan-72x22mm.459a694c.jpg";